import cardService from 'src/services/cards'
import { action } from 'typesafe-actions'
import { CardTypes } from '../types/cards'
import {
  getErrorHelper,
  getValidationErrorMessage,
} from 'src/utils/response-helpers'

export const addMyCardAction = ({ onAddSuccess, onAddError }: any) => {
  return async (dispatch: any) => {
    try {
      const response: any = await cardService.addCards()
      if (response.data.data.payment.successful) {
        onAddSuccess?.(response.data.data.payment.reference)
        dispatch(action(CardTypes.GET_MY_CARDS_CALL))
      } else {
        onAddError?.(response.server_response)
      }
    } catch (error) {
      getErrorHelper(error)
    }
  }
}

export const getMyCardsAction = () => {
  return async (dispatch: any) => {
    try {
      const response: any = await cardService.getMyCards()
      dispatch(action(CardTypes.GET_MY_CARDS_CALL, response.data.data))
    } catch (error) {
      getErrorHelper(error)
    }
  }
}

export const deleteMyCardAction = ({ id, onSuccess, onError }: any) => {
  return async (dispatch: any) => {
    try {
      const response: any = await cardService.deleteCard(id)

      if (!response.data.data.successful) {
        onError(getValidationErrorMessage(response.data.message))
      } else {
        onSuccess?.(response.data.data.server_response)
        dispatch(
          action(CardTypes.DELETE_CARD_REQUEST_SUCCESS, response.data.data)
        )
        dispatch(action(CardTypes.GET_MY_CARDS_CALL))
      }
    } catch (error) {
      onError(getErrorHelper(error))
    }
  }
}
